import { render, staticRenderFns } from "./RxNumber.vue?vue&type=template&id=f3bef6b8&scoped=true"
import script from "./RxNumber.vue?vue&type=script&lang=js"
export * from "./RxNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bef6b8",
  null
  
)

export default component.exports